import styled, { css } from 'styled-components'

const ButtonCircle = styled.div`
  ${({
    theme: {
      colors: { white },
    },
  }) => {
    return css`
      position: absolute;
      width: 46px;
      height: 46px;

      border: 2px solid ${white};
      border-radius: 50%;

      transition: transform 0.2s;

      &:hover {
        transform: scale(1.16);
      }
    `
  }}
`

export default ButtonCircle
